import React, { useEffect } from "react";
import Select from "react-select";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SweetAlert from "react-bootstrap-sweetalert";

import { setLoading } from "@inspinia-react/actions";
import { getStates } from "@parts/utils";

import { setStateLocation, setCityLocation } from "../actions";
import { mapTest } from "../../../pages/products/map.test";

class StateLocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      states: [],
      showNotAllowedModal: false
    };
    this._selectState = this._selectState.bind(this);
  }
  _selectState(e) {
    this.props.setStateLocation(e);
    this.props.setCityLocation({ value: null, label: ""})
  }
  _getStates() {
    const payload = (states) => {
      states.forEach((state) => {
        state.label = state.uf;
        state.value = state.id;
      });
    this.setState({ ...this, states });
    this.props.setLoading(false)
    };
    getStates(payload);
  }
  UNSAFE_componentWillMount() {
    this._getStates();
  }

  render() {
    const { loading } = this.props;
    return (
      <div>
        Estado
        <Select
          isDisabled={loading}
          value={this.props.stateLocation}
          defaultInputValue={this.state.stateName}
          onChange={this._selectState}
          id = {mapTest.createClient.clientAddressState}
          placeholder="Selecione o Estado"
          options={this.state.states}
        />
        <NotAllowedModal
          showNotAllowedModal={this.state.showNotAllowedModal}
          state={this.props.stateLocation}
          onConfirm={() => this.setState({ ...this, showNotAllowedModal: false })}
          onChange={() => this.setState({ ...this, showNotAllowedModal: true })}
          unavailableStates={this.props.unavailableStates}
        />
      </div>
    );
  }
}

function NotAllowedModal(props) {

  useEffect(() => {   
    if (props.unavailableStates) {
      if (["PA", "PR", "AL", "ES", "MG", "RJ", "RS", "SC"].includes(props.state.uf)) {
        props.onChange()
      }
    }
  }, [props.state])
  return <SweetAlert
    show={props.showNotAllowedModal}
    type="info"
    confirmBtnText="Continuar"
    title={`O MEI em ${props.state.uf} não pode emitir NF-e ou NFC-e`}
    onConfirm={props.onConfirm}
  >
    Para saber mais, consulte
    <a href='https://otimizeseunegocio.com/gestao-organizacao/mei-descubra-como-emitir-nota-fiscal-no-seu-estado/' target='_blank'> o link do nosso artigo </a>
    <br /><br />
    Mas você ainda pode fazer a gestão do seu negocio, basta continuar o cadastro.
  </SweetAlert>

}

const mapStateToProps = (state) => ({
  loading: state.loading,
  stateLocation: state.stateLocation,
  stateName: state.stateName
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setStateLocation,
      setCityLocation,
      setLoading,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(StateLocation);



// WEBPACK FOOTER //
// ./src/components/parts/address-component/state-location/index.jsx